// ─── mealStructure.fr ────────────────────────────────────────────────────
// 2026-07-26 (demande Benoit, GO le soir même) — réglage « Structure des
// repas » au cadrage du composer : la décision collation appartient à
// ANISSA (jamais codée en dur, jamais déduite du questionnaire ou de l'IA).
//
// Les libellés générés (« Collation matin : », « Collation : »,
// « Collation soir : ») sont exactement ceux que clientAppMapper.js
// reconnaît (SLOT_PATTERNS + fallback V95.1) — ne pas les reformuler.

export const MEAL_STRUCTURES = [
  { id: 'trois_repas', label: '3 repas, sans collation' },
  { id: 'collation_apres_midi', label: '3 repas + collation après-midi' },
  { id: 'collation_matin_apres_midi', label: '3 repas + collations matin et après-midi' },
  { id: 'collation_soir', label: '3 repas + collation du soir' },
];

const VALID_IDS = new Set(MEAL_STRUCTURES.map((s) => s.id));

/**
 * Bloc de contrainte ajouté EN FIN de prompt système (les deux chemins,
 * composer et legacy) : il PRIME sur les mentions historiques codées en
 * dur (« 3 repas + 1 collation ») des sections ONESHOT / FOUR_WEEKS.
 * Retourne '' si structure inconnue (fail-safe : comportement historique).
 */
export function buildMealStructureConstraintFr(structureId) {
  if (!VALID_IDS.has(structureId)) return '';
  const lines = [
    "STRUCTURE DES REPAS — CHOIX D'ANISSA AU CADRAGE (cette consigne PRIME sur toute mention précédente du nombre de repas ou de collations) :",
  ];
  switch (structureId) {
    case 'trois_repas':
      lines.push(
        '- 3 repas par jour : Petit-dejeuner, Diner (midi), Souper (soir).',
        "- N'écris AUCUNE ligne « Collation » dans la structure alimentaire.",
      );
      break;
    case 'collation_apres_midi':
      lines.push(
        '- 3 repas par jour (Petit-dejeuner, Diner (midi), Souper (soir)) + UNE collation.',
        "- Écris la ligne « Collation : … » entre le dîner et le souper, adaptée au profil et à la phase.",
      );
      break;
    case 'collation_matin_apres_midi':
      lines.push(
        '- 3 repas par jour (Petit-dejeuner, Diner (midi), Souper (soir)) + DEUX collations.',
        "- Écris « Collation matin : … » entre le petit-déjeuner et le dîner, ET « Collation après-midi : … » entre le dîner et le souper.",
      );
      break;
    case 'collation_soir':
      lines.push(
        '- 3 repas par jour (Petit-dejeuner, Diner (midi), Souper (soir)) + UNE collation en soirée.',
        "- Écris la ligne « Collation soir : … » après le souper, légère et adaptée au profil.",
      );
      break;
    default:
      return '';
  }
  return lines.join('\n');
}
